import { Inject, Injectable, LOCALE_ID, OnDestroy } from '@angular/core';
import { IUser } from '../models/user/user.interface';
import { Subscription, Subject } from 'rxjs';
import { QueryParamsService } from './http/queryParams.service';
import { DeployParams } from '../deployParams';
import { QueryParams } from '../models/queryParams';
import { UserProviderService } from './providers/user.provider.service';
import { ICustomNotification } from '../models/notification/customNotification';
import { ErrorLevel, ErrorType } from '../models/enums';
import { NotificationService } from './notification.service';
import { StorageService } from './util/storage.service';
import { DynamicTranslations } from 'src/locale/dynamicTranslations';
import { FreeBetService } from './freeBet.service';
import { BonusService } from './bonus.service';
import { environment } from 'src/environments/environment';


@Injectable()
export class UserService implements OnDestroy {

  user: IUser;
  private subscription: Subscription = new Subscription();
  private userLoggedInOutSource = new Subject<boolean>();
  userLoggedInOut$ = this.userLoggedInOutSource.asObservable();
  private freebetChangedSource = new Subject<boolean>();
  freebetChanged$ = this.freebetChangedSource.asObservable();
  private accountBalanceChangedSource = new Subject<boolean>();
  accountBalanceChanged$ = this.accountBalanceChangedSource.asObservable();
  subscribedEventIds: number[] = [];

  constructor(
    @Inject(LOCALE_ID) locale: string,
    private userProvider: UserProviderService,
    private queryParamService: QueryParamsService,
    private notificationService: NotificationService,
    private storage: StorageService) {
    this.user = {
      userName: null,
      userToken: null,
      userCurrency: null,
      userLanguage: locale.toString(),
      userSBToken: null,
    };

    if (environment.localDeploy) {
      // this.user.userName = DeployParams.LOCAL_USER_ID.toString();
      // this.storage.userName = this.user.userName;
      if (this.storage.userName) {
        this.user.userName = this.storage.userName;
        // this.playerLoginAction();
      }
    }


    // this.user.userSBToken = localStorage.getItem('AuthToken') ? localStorage.getItem('AuthToken') : null;
    this.user.userSBToken = storage.authToken;
    this.subscription.add(this.queryParamService.queryParamsChanged$.subscribe(params => this.paramsChanged(params)));

    // this.authPlayer(this.queryParamService.queryParameters);
  }

  logout(): void {
    // console.log('USER SERVICE logout');
    if (this.user.userSBToken) {
      this.userProvider.playerLogout(this.user.userSBToken).subscribe(res => {
        // console.log('USER logout: ' + JSON.stringify(res));
      });
    }

    this.user.userSBToken = null;
    this.storage.authToken = null;
    this.storage.userName = null;
    this.storage.freeBetBalance = null;
    this.storage.accountBalance = null;
    this.accountBalanceChangedSource.next();
    this.freebetChangedSource.next();
    this.userLoggedInOutSource.next(false);
  }

  loginLocalUser(userId: number){
    this.logout();
    this.user.userName = userId.toString();
    this.storage.userName = this.user.userName;
    this.playerLoginAction();
  }

  paramsChanged(params: QueryParams): void {
    // if (this.user.userLanguage && this.user.userLanguage !== params.userLanguage) {
    //   // localStorage.setItem('languageId', params.userLanguage);
    //   this.storage.language = params.userLanguage;
    //   window.location.reload();
    // }
    if (environment.localDeploy) {
      return;
    }
    this.authPlayer(params);
  }

  authPlayer(params: QueryParams): void {
    // console.log('USER SERVICE auth pl name: ' + params.userName + ' token: ' + params.userToken);
    if (this.user.userLanguage == null) {
      // this.user.userLanguage = localStorage.getItem('languageId');
      this.user.userLanguage = this.storage.language;
    }


    if (this.user.userLanguage == null) {
      return;
    }

    this.user.userCurrency = params.userCurrency;
    this.user.userToken = params.userToken;

    this.user.userSBToken = this.storage.authToken;

    if (this.user.userSBToken != null) {
      if (!this.user.userToken || this.user.userToken === '') {
        this.logout();
      }
    }

    this.user.userName = params.userName;
    this.storage.userName = this.user.userName;

    // if (!this.user.userName && environment.localDeploy) {
    //   this.user.userName = DeployParams.LOCAL_USER_ID.toString();
    //   this.storage.userName = this.user.userName;
    // }

    if (this.user.userName != null && this.user.userToken != null) {
      // console.log('USER SERVICE login');
      this.playerLoginAction();
    }
  }

  private playerLoginAction() {
    this.userProvider.authPlayer(this.user).subscribe(bl => {
      if (bl != null) {
        if (bl.code == null || bl.code === 0) {
          this.user.userSBToken = bl.token;

          // console.log('USER SERVICE login success, token: ' + bl.token);
          this.storage.authToken = this.user.userSBToken;
          this.storage.userName = this.user.userName;

          this.userProvider.getFreeBetBalance(
            this.user.userName,
            this.user.userLanguage,
            this.user.userCurrency).subscribe(balance => {
              this.storage.freeBetBalance = balance;
              this.freebetChangedSource.next();
            });

          this.userProvider.getAccountBalance(
            this.user.userName,
            this.user.userLanguage,
            this.user.userCurrency,
            this.user.userName).subscribe(balance => {
              // sessionStorage.setItem('ABalance', balance.toString());
              this.storage.accountBalance = balance;
              this.accountBalanceChangedSource.next();
            });
          this.userLoggedInOutSource.next(true);

        } else {
          // console.log('USER SERVICE login failed');
          const notification = {
            title: DynamicTranslations.notification_title,
            message: DynamicTranslations.notification_LoginFailedWrongToken_ErrorMessage,
            errorLevel: ErrorLevel.Notification,
            errorType: ErrorType.Reload
          };
          this.notificationService.forwardDataToNotification(notification as ICustomNotification);

          this.storage.authToken = null;
          this.storage.userName = null;
          this.userLoggedInOutSource.next(false);
        }
      }
    });
  }

  getNewBalancesFromServer() {
    if (this.user.userSBToken) {
      this.userProvider.getFreeBetBalance(
        this.user.userName,
        this.user.userLanguage,
        this.user.userCurrency).subscribe(balance => {
          this.storage.freeBetBalance = balance;
          this.freebetChangedSource.next();
        });

      this.userProvider.getAccountBalance(
        this.user.userName,
        this.user.userLanguage,
        this.user.userCurrency,
        this.user.userName).subscribe(balance => {
          this.storage.accountBalance = balance;
        });
    }
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
